// src/components/IEDSiteMapLayer.jsx
import { useEffect } from 'react';
import { loadModules } from 'esri-loader';

const IEDSiteMapLayer = ({ view }) => {
  useEffect(() => {
    if (!view || !view.map) return;

    let mapImageLayer;
    let isMounted = true;

    loadModules(['esri/layers/MapImageLayer']).then(([MapImageLayer]) => {
      mapImageLayer = new MapImageLayer({
        url: 'https://air.discomap.eea.europa.eu/arcgis/rest/services/Air/IED_SiteMap/MapServer',
        sublayers: [
          {
            title: '> 50 MW Thermal (2023)',
            id: 0,
            queryable: true,
            popupEnabled: true
          }
        ]
      });

      mapImageLayer.when().then(() => {
        if (!isMounted) return;

        const sublayer = mapImageLayer.findSublayerById(0);
        if (sublayer) {
          sublayer.popupTemplate = {
            title: '{facilityNames}',
            content: 'Activity: {eprtr_AnnexIActivity}<br>URL: {rbds}'
          };

          sublayer.definitionExpression =
            "(plantTypes LIKE '%LCP%') AND (Site_reporting_year = 2023) AND ((facilityTypes LIKE 'EPRTR%') OR (facilityTypes LIKE '% EPRTR')) AND (count_instype_IED >= 1)";

          sublayer.renderer = {
            type: 'simple',
            symbol: {
              type: 'simple-marker',
              style: 'square',
              color: [0, 122, 0, 0.8],
              size: 8,
              outline: {
                color: [0, 0, 0, 0.5],
                width: 1
              }
            }
          };
        }

        // ✅ Add the layer only after it's ready
        if (view.map) {
          view.map.add(mapImageLayer);
        }
      }).catch((err) => {
        if (err.name !== 'AbortError') {
          console.error('IEDSiteMapLayer load error:', err);
        }
      });
    });

    return () => {
      isMounted = false;
      if (mapImageLayer && view?.map) {
        view.map.remove(mapImageLayer);
      }
    };
  }, [view]);

  return null;
};

export default IEDSiteMapLayer;
